export let RuleGroupId = /*#__PURE__*/function (RuleGroupId) {
  RuleGroupId["SiteLevel"] = "site-level";
  RuleGroupId["StaticPage"] = "static-page";
  RuleGroupId["ProductPage"] = "product-page";
  RuleGroupId["ServicePage"] = "service-page";
  RuleGroupId["BlogPosts"] = "blog-posts";
  RuleGroupId["EventPage"] = "event-page";
  RuleGroupId["PageLevel"] = "page-level";
  RuleGroupId["PortfolioProjects"] = "portfolio-projects";
  RuleGroupId["OnlinePrograms"] = "online-programs";
  RuleGroupId["RestaurantsMenu"] = "restaurants-menu";
  RuleGroupId["GroupPage"] = "group-page";
  return RuleGroupId;
}({});
export let RuleId = /*#__PURE__*/function (RuleId) {
  RuleId["VALID_STATIC_PAGE_TITLE"] = "VALID_PAGE_TITLE";
  RuleId["VALID_SERVICE_PAGE_TITLE"] = "VALID_SERVICE_PAGE_TITLE";
  RuleId["VALID_PRODUCT_PAGE_TITLE"] = "VALID_PRODUCT_PAGE_TITLE";
  RuleId["UNIQUE_PAGE_TITLE"] = "UNIQUE_PAGE_TITLE";
  RuleId["MAIN_HEADING"] = "MAIN_HEADING";
  RuleId["VISUAL_INDICATORS"] = "VISUAL_INDICATORS";
  RuleId["SKIP_TO_MAIN_CONTENT"] = "SKIP_TO_MAIN_CONTENT";
  RuleId["SITE_LANGUAGE"] = "SITE_LANGUAGE";
  RuleId["HEADING_DEFINITION"] = "HEADING_DEFINITION";
  RuleId["HEADING_STRUCTURE"] = "HEADING_STRUCTURE";
  RuleId["STATIC_ALT_TEXT"] = "STATIC_ALT_TEXT";
  RuleId["STATIC_TEXT_IN_IMAGE"] = "STATIC_TEXT_IN_IMAGE";
  RuleId["PRODUCT_ALT_TEXT"] = "PRODUCT_ALT_TEXT";
  RuleId["POST_ALT_TEXT"] = "POST_ALT_TEXT";
  RuleId["SERVICE_ALT_TEXT"] = "SERVICE_ALT_TEXT";
  RuleId["EVENT_ALT_TEXT"] = "EVENT_ALT_TEXT";
  RuleId["ONLINE_PROGRAMS_ALT_TEXT"] = "ONLINE_PROGRAMS_ALT_TEXT";
  RuleId["RESTAURANTS_MENU_ALT_TEXT"] = "RESTAURANTS_MENU_ALT_TEXT";
  RuleId["COLOR_CONTRAST"] = "COLOR_CONTRAST";
  RuleId["DOM_ORDER"] = "DOM_ORDER";
  RuleId["GROUP_PAGE_ALT_TEXT"] = "GROUP_PAGE_ALT_TEXT";
  RuleId["MEDIA_ALTERNATIVES"] = "MEDIA_ALTERNATIVES";
  RuleId["INACCESSIBLE_COMPONENTS"] = "INACCESSIBLE_COMPONENTS";
  RuleId["INACCESSIBLE_LAYOUT"] = "INACCESSIBLE_LAYOUT";
  RuleId["PAGE_AUTO_DOM_ORDER"] = "PAGE_AUTO_DOM_ORDER";
  return RuleId;
}({});
//# sourceMappingURL=ids.js.map